export default __webpack_public_path__ + "static/media/banner-2.d85beca5.jpg";